document.addEventListener("DOMContentLoaded", () => {
  // Toggle menu
  // --------------
  var mainHeader = document.querySelector("header.main-header");
  var menu = mainHeader.querySelector("nav");
  var toggleDropdowns = menu.querySelectorAll(".dropdown-toggle");

  function deactivateAllDropdowns() {
    toggleDropdowns.forEach(function (dropdown) {
      dropdown.classList.remove("active");
      // Update the parent li element's ARIA attribute
      dropdown.parentElement.setAttribute("aria-expanded", "false");
    });
  }

  var dropdownActive = false;

  toggleDropdowns.forEach(function (dropdown) {
    dropdown.addEventListener("click", function (event) {
      event.preventDefault();

      if (dropdown.classList.contains("active")) {
        deactivateAllDropdowns();
        dropdownActive = false;
      } else {
        deactivateAllDropdowns();
        dropdown.classList.add("active");
        // Update the parent li element's ARIA attribute
        dropdown.parentElement.setAttribute("aria-expanded", "true");
        dropdownActive = true;
      }
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && dropdownActive) {
      deactivateAllDropdowns();
      dropdownActive = false;
    }
  });

  // Close dropdown if click outside header or dropdown
  document.addEventListener("click", function (event) {
    if (dropdownActive) {
      if (!mainHeader.contains(event.target)) {
        deactivateAllDropdowns();
        dropdownActive = false;
      }
    }
  });

  var menuActive = false;

  function openMenu() {
    if (!menuActive) {
      menuActive = true;
      document.documentElement.classList.add("backdrop-active");
      document.documentElement.classList.add("mobile-menu-active");
      menu.setAttribute("data-menu-active", "");
      mainHeader.focus();
    }
  }

  function closeMenu() {
    if (menuActive) {
      menuActive = false;
      document.documentElement.classList.remove("backdrop-active");
      document.documentElement.classList.remove("mobile-menu-active");
      menu.removeAttribute("data-menu-active");
      mainHeader.blur();
    }
  }

  document
    .querySelector("[data-open-menu]")
    .addEventListener("click", function () {
      return openMenu();
    });
  document
    .querySelector("[data-close-menu]")
    .addEventListener("click", function () {
      return closeMenu();
    });

  menu.addEventListener("click", (event) => {
    if (event.target.dataset.menuActive !== undefined) {
      event.preventDefault();
      return closeMenu();
    }
  });

  mainHeader.addEventListener("keyup", (event) => {
    if (menuActive) {
      if (event.code.toUpperCase() === "ESCAPE") {
        return closeMenu();
      }
    }
  });

  mainHeader.addEventListener("click", function (event) {
    if (event.target.nodeName == "A") {
      var headerClickEvent = new CustomEvent("performance.selectContent", {
        detail: {
          content_type: "Header link",
          content_id: event.target.href
        }
      });
      window.dispatchEvent(headerClickEvent);
    }
  });
});
